import { Component, React, observer, resolveCss } from '$src/handy'
import * as css from './DateRangeInput.css'
import { asField } from '$src/common/forms'
import FaRegQuestionCircle from 'react-icons/lib/fa/question-circle-o'
import ReactTooltip from 'react-tooltip'
import { DateRangePicker } from 'react-dates'
import 'react-dates/lib/css/_datepicker.css'
import 'react-dates/initialize'
import moment from 'moment'

interface Props {
  css?: any
  type?: 'text' | 'password'
  tip?: string
  name: string
  label: string
  placeholder?: string
  value: any
  onChange: (v: any) => void
}

@observer
export default class DateRangeInput extends Component<
Props,
{ focusedInput: any, hasError: boolean }
> {
  static Field: any

  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {
      focusedInput: null,
      hasError: false
    }
  }

  _onChange = (e: any) => {
    this.setState({ hasError: false })

    if (e.startDate === null || e.endDate === null) {
      this.setState({ hasError: true })
    }

    this.props.onChange({
      startDate: e.startDate && e.startDate.unix(),
      endDate: e.endDate && e.endDate.unix(),
    })
  }

  render() {
    const { props } = this
    const classes = resolveCss(css, props.css)

    const value = props.value || { startDate: null, endDate: null }

    return (
      <div {...classes('container')}>
        <div {...classes('label')}>
          <label>{props.label}</label>
          {props.tip && (
            <FaRegQuestionCircle data-tip={props.tip} data-for="date-help" />
          )}
          <ReactTooltip
            id="date-help"
            effect="solid"
            place="top"
            type="light"
            delayHide={100}
            border={true}
            multiline={true}
          />
        </div>
        <DateRangePicker
          startDate={value.startDate && moment.unix(value.startDate)}
          endDate={value.endDate && moment.unix(value.endDate)}
          onDatesChange={this._onChange}
          noBorder={true}
          startDateId="startDate"
          endDateId="endDate"
          isOutsideRange={() => false}
          focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
          onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
          displayFormat="D.M.YYYY"
          firstDayOfWeek={1}
        />
        {this.state.hasError && (
          <p {...classes('dateError')}>Please use the correct date format. Ie: 1.8.2022</p>
          )
        }
      </div>
    )
  }
}

DateRangeInput.Field = asField()(DateRangeInput)



// WEBPACK FOOTER //
// ./src/common/DateRangeInput.tsx